import classNames from 'classnames'
import CustomSelect from 'client/components/common/CustomSelect'
import { DocumentType } from 'client/Interfaces/Draft/DraftInterface'
import { l } from 'client/Other/Translation'
import { setBaseClass } from 'client/utils'
import { difference } from 'lodash'
import * as React from 'react'

import './ColumnsSettings.scss'

const columns = {
  invoice: ['index', 'date', 'quantity', 'unit', 'unitPrice', 'taxTotal'],
  receipt: ['index', 'date', 'quantity', 'unit', 'vatPct', 'unitPrice', 'taxTotal'],
  estimate: ['index', 'date', 'quantity', 'unit', 'vatPct', 'unitPrice', 'taxTotal'],
  deliverynote: ['index', 'date', 'quantity', 'unit'],
}
interface ColumnSettingsProps {
  value: string
  documentType: DocumentType
  onChange: (newValue: string) => void
}

export const cls = setBaseClass('ColumnsSettingsSelect')

const ColumnSettings: React.FC<ColumnSettingsProps> = ({ documentType, value, onChange }) => {
  const valueSplitted = React.useMemo(() => value.split(','), [value])

  const isSelected = (column) => {
    return valueSplitted.includes(column)
  }

  const shouldShowColumnOption = (column) => {
    return column !== 'taxTotal' || isSelected('vatPct')
  }

  const isTotalSelected = (column) => {
    const totalSelected = valueSplitted.includes('total')
    const netTotalSelected = valueSplitted.includes('netTotal')
    const bothSelected = totalSelected && netTotalSelected
    if (column === 'bothTotals') {
      return bothSelected
    } else {
      return (column === 'total' ? totalSelected : netTotalSelected) && !bothSelected
    }
  }

  const handleClick = (column) => {
    const valueIsSelected = valueSplitted.includes(column)
    let newValue = valueIsSelected ? valueSplitted.filter((c) => c !== column).join(',') : value.concat(`,${column}`)
    if (!newValue.includes('vatPct')) {
      newValue = difference(newValue.split(','), ['taxTotal', 'netTotal']).join(',')
    }
    onChange(newValue)
  }
  return (
    <CustomSelect
      className={cls()}
      label={l('invoice.Fields')}
      value={valueSplitted
        .filter((column) => column !== 'description')
        .map((column) => l(`invoice.line.${column}`))
        .join(', ')}
    >
      <ul className={cls('__list')}>
        {columns[documentType].map((column) => {
          return (
            shouldShowColumnOption(column) && (
              <li
                key={column}
                className={classNames(cls('__option'), { [cls('__option--selected')]: isSelected(column) })}
                onClick={() => handleClick(column)}
              >
                {l(`invoice.line.${column}`)}
              </li>
            )
          )
        })}
      </ul>
      {isSelected('vatPct') && (
        <>
          <span className={cls('__optionsTitle')}>{l('invoice.visibleTotalColumns')}</span>
          {['total', 'netTotal', 'bothTotals'].map((column) => {
            return (
              <div
                key={column}
                className={cls('__totalsRadio')}
                onClick={() => {
                  let newValue = difference(valueSplitted, ['total', 'netTotal'])
                  if (column === 'bothTotals') {
                    newValue = newValue.concat(['total', 'netTotal'])
                  } else {
                    newValue = newValue.concat(column)
                  }
                  onChange(newValue.join(','))
                }}
              >
                <div
                  className={classNames(cls('__radioCheck'), {
                    [cls('__radioCheck--checked')]: isTotalSelected(column),
                  })}
                ></div>
                <label className={cls('__radioLabel')}>{l(`invoice.line.${column}`)}</label>
              </div>
            )
          })}
        </>
      )}
    </CustomSelect>
  )
}

export default ColumnSettings
